import { Icon } from '@iconify/react';
import dashboardIcon from '../../assets/icons/icon_dashboard.svg';
import reportIcon from '../../assets/icons/icon_report.svg';
import favouriteIcon from '../../assets/icons/icon_favourite.svg';
import datatsetsIcon from '../../assets/icons/icon_datasets.svg';
import { DecryptData } from '../../utils/encryptDecrypt';
// ----------------------------------------------------------------------
const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

let configUpdate = {
  dashboard: { seq: 1, icon: <img src={dashboardIcon} /> },
  report: { seq: 2, icon: <img src={reportIcon} /> },
  favourites: { seq: 3, icon: <img src={favouriteIcon} /> },
  datasets: { seq: 4, icon: <img src={datatsetsIcon} /> },
  usertype: { seq: 5, icon: <img src={datatsetsIcon} /> },
  role: { seq: 6, icon: <img src={datatsetsIcon} /> },
  dataSource: { seq: 7, icon: <img src={datatsetsIcon} /> },
  userManagement: { seq: 8, icon: <img src={datatsetsIcon} /> },
  settings: { seq: 9, icon: <img src={datatsetsIcon} /> },
  preAggregation: { seq: 10, icon: <img src={datatsetsIcon} /> },
  calculatedFields: { seq: 11, icon: <img src={datatsetsIcon} /> },
  publishedDashboard: { seq: 12, icon: <img src={dashboardIcon} /> },
  downloadReports: { seq: 13, icon: <img src={reportIcon} /> }
}

// const sidebarConfig = [
//   {
//     title: 'dashboard',
//     path: '/dashboard',
//     label: 'Dashboard',
//     value: 'dashboard',
//     icon: <img src={dashboardIcon} />,
//     accessRole: ["superadmin"]
//   },
//   {
//     title: 'reports',
//     path: '/report',
//     label: 'Reports',
//     value: 'report',
//     icon: <img src={reportIcon} />,
//     accessRole: ["superadmin"]
//   },
//   {
//     title: 'favourites',
//     path: '/favourites',
//     label: 'Favourites',
//     value: 'favourites',
//     icon: <img src={favouriteIcon} />,
//     accessRole: ["superadmin"]
//   },
//   {
//     title: 'datasets',
//     path: '/datasets',
//     label: 'Datasets',
//     value: 'datasets',
//     icon: <img src={datatsetsIcon} />,
//     accessRole: ["superadmin"]
//   },
//   {
//     title: 'user type',
//     path: '/usertype',
//     label: 'User Type',
//     value: 'usertype',
//     icon: <img src={datatsetsIcon} />,
//     accessRole: ["superadmin"]
//   },
//   {
//     title: 'role',
//     path: '/role',
//     label: 'Role',
//     value: 'role',
//     icon: <img src={datatsetsIcon} />,
//     accessRole: ["superadmin"]
//   }
// ];



function updateConfigRole(sidebarList) {
  let CurrentRole = DecryptData(localStorage.getItem('role'))
  let UserAllowedMenus = localStorage.getItem('menusAllowed') ? JSON.parse(DecryptData(localStorage.getItem('menusAllowed'))) : []
  if (sidebarList && sidebarList.length) {
    for (let menuObj of sidebarList) {
      let config = configUpdate[menuObj.value];
      menuObj.icon = config.icon;
      let FindInAllowedMenu = UserAllowedMenus.find(obj => obj.menuId === menuObj.value)

      if (menuObj?.accessRole) {
        menuObj.accessRole.push('superadmin')
      }
      else {
        menuObj.accessRole = ['superadmin']
      }

      if (FindInAllowedMenu) {
        menuObj.accessRole.push(CurrentRole)
      }
    }
    return sidebarList
  }
}




export default updateConfigRole;
